/* =====================================================================
   HP Product Sticky Bar — mostra una barra fissa in alto quando si scrolla
   oltre il titolo del prodotto. Riusa i dati del DOM (titolo, marchio,
   prezzo, immagine) e il bottone "Aggiungi" triggera quello reale del form.
   ===================================================================== */
(function () {
  if (window.__hpProdStickyInit) return;
  window.__hpProdStickyInit = true;
  window.__hpPSBVersion = 'scroll-v8';

  function init() {
    var title = document.querySelector('.hp-pt__title');
    if (!title) return; /* non e' una pagina prodotto con il nostro snippet */

    var vendor = document.querySelector('.hp-pt__vendor');
    var priceSrc = document.querySelector('.product-info__price-wrapper .price__content, .product-info__price-wrapper, .price__container .price__content, .price__container');
    var img = document.querySelector('.product__media img, .media-gallery-item__media img, .media-gallery-item__media, .product-media img, [class*="gallery"] img');

    var bar = document.createElement('div');
    bar.className = 'hp-psb';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="hp-psb__inner">' +
        '<div class="hp-psb__info">' +
          '<span class="hp-psb__thumb"></span>' +
          '<span class="hp-psb__text">' +
            '<span class="hp-psb__title"></span>' +
            '<span class="hp-psb__vendor"></span>' +
          '</span>' +
        '</div>' +
        '<div class="hp-psb__actions">' +
          '<span class="hp-psb__price"></span>' +
          '<button type="button" class="hp-psb__add">Aggiungi</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(bar);

    bar.querySelector('.hp-psb__title').textContent = title.textContent.trim();
    var vEl = bar.querySelector('.hp-psb__vendor');
    if (vendor && vendor.textContent.trim()) { vEl.textContent = vendor.textContent.trim(); }
    else { vEl.style.display = 'none'; }

    var thumb = bar.querySelector('.hp-psb__thumb');
    var thumbSrc = '';
    if (img && img.tagName === 'IMG') thumbSrc = img.currentSrc || img.getAttribute('src') || '';
    if (!thumbSrc) { var og = document.querySelector('meta[property="og:image"]'); if (og) thumbSrc = og.getAttribute('content') || ''; }
    if (thumbSrc) thumb.style.backgroundImage = 'url("' + thumbSrc + '")';
    else thumb.style.display = 'none';

    var priceBox = bar.querySelector('.hp-psb__price');
    function syncPrice() {
      var src = document.querySelector('.product-info__price-wrapper .price__content, .price__container .price__content, .price__content');
      if (src) priceBox.innerHTML = src.innerHTML;
      else if (priceSrc) priceBox.textContent = priceSrc.textContent.replace(/\s+/g, ' ').trim();
    }
    syncPrice();
    if (priceSrc && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(priceSrc, { childList: true, subtree: true, characterData: true });
    }

    /* Bottone Aggiungi -> AJAX add al carrello (NON apre il drawer) +
       feedback "Aggiunto" con spunta per ~2s. */
    var addBtn = bar.querySelector('.hp-psb__add');
    function getVariantId() {
      /* 1) input/select name=id popolato (variante selezionata dall'utente) */
      var f = document.querySelector('form[action*="/cart/add"] [name="id"], product-form [name="id"], [name="id"]');
      if (f && f.value) return f.value;
      /* 2) parametro URL */
      var u = new URLSearchParams(location.search).get('variant');
      if (u) return u;
      /* 3) product/variant JSON (lo snippet espone una variante con .id) */
      try {
        var pj = document.querySelector('script[type="application/json"][data-product-json], product-info script[type="application/json"], script[id*="ProductJson"]');
        if (pj) {
          var d = JSON.parse(pj.textContent);
          if (d && d.id) return d.id;
          var variants = d.variants || (d.product && d.product.variants);
          if (variants && variants.length) { var a = variants.find(function (v) { return v.available; }) || variants[0]; return a.id; }
          if (d.selected_or_first_available_variant) return d.selected_or_first_available_variant.id;
        }
      } catch (e) {}
      return null;
    }
    /* sezione (header) che contiene il cart-drawer: la ri-renderizziamo via
       Section Rendering API per aggiornare drawer + badge in tempo reale. */
    var drawerSectionId = (function () {
      var d = document.querySelector('cart-drawer, #CartDrawer');
      var s = d ? d.closest('[id^="shopify-section-"]') : null;
      return s ? s.id.replace('shopify-section-', '') : null;
    })();
    function applySections(sections) {
      if (!sections || !drawerSectionId || !sections[drawerSectionId]) return false;
      var tmp = document.createElement('div');
      tmp.innerHTML = sections[drawerSectionId];
      var ok = false;
      ['#CartDrawer', '#cart-icon-bubble', '#cart-icon-bubble-mobile'].forEach(function (sel) {
        var nw = tmp.querySelector(sel), cur = document.querySelector(sel);
        if (nw && cur) { cur.innerHTML = nw.innerHTML; if (nw.className) cur.className = nw.className; ok = true; }
      });
      return ok;
    }
    function fallbackBadge() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('#cart-icon-bubble, [data-cart-count], [class*="cart-count"]').forEach(function (el) {
            if (el.children.length === 0 && /^\s*\d*\s*$/.test(el.textContent)) el.textContent = cart.item_count;
          });
        }).catch(function () {});
    }
    function notifyCart(cart) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
    }
    addBtn.addEventListener('click', function () {
      if (addBtn.getAttribute('data-busy')) return;
      var vid = getVariantId();
      if (!vid) return; /* nessun variant id affidabile: non navighiamo a /cart/add */
      addBtn.setAttribute('data-busy', '1');
      var payload = { items: [{ id: vid, quantity: 1 }] };
      if (drawerSectionId) { payload.sections = [drawerSectionId]; payload.sections_url = location.pathname; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res && res.status && res.status !== 200) { addBtn.removeAttribute('data-busy'); return; }
        if (!applySections(res.sections)) { fallbackBadge(); }
        notifyCart(res);
        addBtn.classList.add('is-added');
        addBtn.innerHTML = '<svg class="hp-psb__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>Aggiunto';
        setTimeout(function () {
          addBtn.classList.remove('is-added');
          addBtn.textContent = 'Aggiungi';
          addBtn.removeAttribute('data-busy');
        }, 3000);
      }).catch(function () {
        addBtn.removeAttribute('data-busy');
      });
    });

    /* Mostra/nascondi via scroll: la bar appare quando il bordo inferiore del
       titolo originale passa sopra l'header (cioe' il titolo e' scrollato via). */
    var headerEl = document.querySelector('.herba-header-sticky-wrapper, #x-header-container, .section-header');
    function update() {
      /* posiziona la bar ESATTAMENTE sul bordo inferiore dell'header reale
         (che su mobile puo' ridursi allo scroll) -> nessuno spazio sopra */
      var hBottom = headerEl ? headerEl.getBoundingClientRect().bottom : (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--hp-header-h'), 10) || 120);
      if (hBottom < 0) hBottom = 0;
      bar.style.top = hBottom + 'px';
      var rect = title.getBoundingClientRect();
      var show = rect.bottom < (hBottom + 6);
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    /* La testata puo' cambiare altezza anche a pagina ferma (su telefono la riga dei link
       si richiude scorrendo): la bar la segue senza aspettare il prossimo scroll. */
    if (window.ResizeObserver && headerEl) new ResizeObserver(update).observe(headerEl);
    update();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
